export const POPOVERS = {
  TEMPLATE_SETTINGS_ACTIONS: 'TEMPLATE_SETTINGS_ACTIONS',
  EMAIL_HEADER_ACTIONS: 'EMAIL_HEADER_ACTIONS',
  EMAIL_PREVIEW_BUTTON: 'EMAIL_PREVIEW_BUTTON',
  EMAIL_EDITOR_DISPLAY_OPTIONS: 'EMAIL_EDITOR_DISPLAY_OPTIONS',
  EMAIL_PREVIEW_DISPLAY_OPTIONS: 'EMAIL_PREVIEW_DISPLAY_OPTIONS'
};